export default "__VITE_ASSET__DNJDffEg__"